module.exports = __webpack_public_path__ + "img/Icon-sidebar-dashboard.4ab7146f.svg";